const ClassStyle = {
    input: "w-full mt-1 border border-gray-300 rounded px-3 py-2",
    input2: "border px-2 py-2 rounded",
    button: "bg-blue-600 text-white px-4 py-2 rounded",
    buttonGreen: "bg-green-600 text-white px-4 py-2 rounded",
    buttonWarning: "bg-yellow-600 text-white px-4 py-2 rounded",
    label1: "block text-sm font-medium text-gray-700 mb-1"
}
export default ClassStyle